import memoize from 'just-memoize';
export default memoize;
